import React from 'react';
import { Link } from 'react-router-dom';
import { Spinner } from '../../components/ui';
import { fmtDate, fmtTime, money } from '../../utils/helpers';
import { SERVICE_STATUSES, isPerUnit } from './useServices';
import ServiceForm from './ServiceForm';
import '../../styles/money.css';

const statusChip = (s) => s === 'Done' ? 'chip ok' : s === 'Confirmed' ? 'chip male' : s === 'Cancelled' ? 'chip danger' : 'chip pend';

// Desktop Services — day-grouped table (money right-aligned) with compact
// money tiles on top.
export default function ServicesDesktop({ vm }) {
  const {
    canView, canAdd, canEdit, canDelete, byDay, filtered, totals, loading,
    q, setQ, typeFilter, setTypeFilter, types, open, openAdd, openEdit, del, setStatus,
  } = vm;

  if (!canView) {
    return (
      <div>
        <div className="page-head"><h1>Services</h1></div>
        <div className="card card-pad empty">You do not have access to services for this event.</div>
      </div>
    );
  }

  return (
    <div>
      <div className="page-head">
        <h1>Services</h1>
        <span className="muted">{filtered.length}</span>
        <div className="spacer" />
        <select value={typeFilter} onChange={e => setTypeFilter(e.target.value)} title="Filter by service"
          style={{ padding: '9px 12px', border: '1px solid var(--line)', borderRadius: 10, maxWidth: 200 }}>
          <option value="">All services</option>
          {types.map(t => <option key={t.ServiceTypeId} value={t.ServiceTypeId}>{t.ServiceTypeName}</option>)}
        </select>
        <input placeholder="Search…" value={q} onChange={e => setQ(e.target.value)}
          style={{ padding: '9px 12px', border: '1px solid var(--line)', borderRadius: 10, maxWidth: 180 }} />
        {canAdd && <button className="btn primary" onClick={openAdd}>+ Add Service</button>}
      </div>

      <div className="mn-tiles">
        <div className="mn-tile"><span>Agreed total</span><strong>{money(totals.total)}</strong></div>
        <div className="mn-tile ok"><span>Paid</span><strong>{money(totals.advance)}</strong></div>
        <div className="mn-tile due"><span>Balance</span><strong>{money(totals.balance)}</strong></div>
        <div className="mn-tile"><span>Plates / units confirmed</span><strong>{totals.plates}</strong></div>
      </div>

      {loading ? <div className="card card-pad"><Spinner /></div>
        : filtered.length === 0 ? (
          <div className="card card-pad empty">
            No services yet. Add the caterer, the event manager, the DJ … each with its charges and advance.
          </div>
        ) : byDay.map(group => (
          <div key={group.date || 'nodate'} style={{ marginBottom: 14 }}>
            <div className="step-label">{group.date ? fmtDate(group.date) : 'No date yet'}</div>
            <div className="card table-wrap">
              <table className="tbl compact">
                <thead>
                  <tr>
                    <th className="grow">Service</th><th>Company / owner</th><th>Function</th><th>Time</th>
                    <th className="mn-r">Rate</th><th className="num">Units</th><th className="mn-r">Total</th>
                    <th className="mn-r">Paid</th><th className="mn-r">Balance</th><th>Status</th><th></th>
                  </tr>
                </thead>
                <tbody>
                  {group.items.map(row => (
                    <tr key={row.ServiceId} className="row-link" title="Open menu / jobs and payments">
                      <td className="grow">
                        <Link to={`/app/services/${row.ServiceId}`} style={{ fontWeight: 700 }}>{row.ServiceType}</Link>
                        {row.Notes && <div className="sub">{row.Notes}</div>}
                      </td>
                      <td>
                        {row.CompanyName || '—'}
                        <div className="sub">{row.ContactName || row.VendorName || ''}{row.ContactMobile ? ` · ${row.ContactMobile}` : ''}</div>
                      </td>
                      <td>{row.FunctionName || 'Whole event'}</td>
                      <td>{fmtTime(row.StartTime || row.FunctionStartTime)}{(row.EndTime || row.FunctionEndTime) ? ` – ${fmtTime(row.EndTime || row.FunctionEndTime)}` : ''}</td>
                      <td className="mn-r">{row.itemised ? 'Itemised' : <>{money(row.Rate)}{isPerUnit(row.RateType) ? ` /${row.RateType === 'PerPlate' ? 'plate' : row.RateType === 'PerDay' ? 'day' : 'hr'}` : ''}</>}</td>
                      <td className="num">{!row.itemised && isPerUnit(row.RateType) ? row.ConfirmedCount : '—'}</td>
                      <td className="mn-r">{money(row.TotalAmount)}</td>
                      <td className="mn-r">{money(row.AdvancePaid)}</td>
                      <td className={'mn-r' + (Number(row.BalanceAmount) > 0 ? ' mn-due' : '')}><strong>{money(row.BalanceAmount)}</strong></td>
                      <td onClick={(e) => e.stopPropagation()}>
                        {canEdit ? (
                          <select value={row.Status} className={statusChip(row.Status)} onChange={e => setStatus(row, e.target.value)}>
                            {SERVICE_STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
                          </select>
                        ) : <span className={statusChip(row.Status)}>{row.Status}</span>}
                      </td>
                      <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }} onClick={(e) => e.stopPropagation()}>
                        <Link className="btn light sm" to={`/app/services/${row.ServiceId}`}>Open</Link>
                        {canEdit && <button className="icon-btn" title="Edit" onClick={() => openEdit(row)}>✎</button>}
                        {canDelete && <button className="icon-btn danger" title="Remove" onClick={() => del(row)}>🗑</button>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))}

      {open && <ServiceForm vm={vm} />}
    </div>
  );
}
